module.exports = __webpack_public_path__ + "static/media/svan-min.82bc5f3d.png";